<template>
  <transition name="appfade">
    <div v-show="appIsLoaded" class="generic-page--template page-template">
      <div class="db relative center z-0 w-100 h-auto">
        <div class="container-fluid">
          <section class="db relative center mw8 tc pt5 pt6-ns pb5">
              <h3 class="tc mv4 ttu is-bebas is-white page-title">{{ page.title }}</h3>
              <div class="db relative center mw8 br2">
                <div class="row middle-sm mv3 mv4-ns">
                  <div class="col-xs-6 col-sm-4 center" v-for="partner in page.Partners" v-if="partner.is_published">
                    <a class="flex relative center flex-row items-center w-100 mv0 aspect-ratio--1x1 bg-center pointer br2" :href="partner.link" target="_blank">
                      <img class="db absolute center left-0 right-0 abs-vert-center img-responsive ph2 mw5-ns" :src="partner.image" :data-src="partner.image" />
                      <!-- <img class="db absolute center left-0 right-0 abs-vert-center img-responsive ph2 mw5-ns" :class="partner.css_class" :src="partner.image" :data-src="partner.image" /> -->
                    </a>
                  </div>
                </div>
              </div>
          </section>
        </div>
      </div>
    </div>
  </transition> 
</template>

<script>
//import { bus } from '../assets/js/src/main';
import Marked from 'marked';
export default {
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_name : this.$site_name;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      newItem: 'Data binding',
      newDynamic: [],
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    }
  },
  methods : {
    //
  },
  mounted() {

    this.$nextTick(() => {
      /****************************
        DOC READY
      ****************************/
      $(function() {

      })


    })


        
  }
}
</script>